export default __webpack_public_path__ + "6073c33006ceed661792240ff4ac78e9.svg";